import React from 'react'
import { startSxpProxy } from '../../../utils/api'
import { ADMIN_PROJECT_ID, CHAT_PROJECT_ID } from '../../../utils/constants'
import { useAppSelector } from '../../../app/hooks'
import { selectSelectedLocationId } from '../../location/locationSlice'
import { odooPharmacyLink, proposed } from '../models'
import useCustomStyles from '../../../utils/hooks/CustomStylesHook'
import { Button, useTheme } from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import {
  paidTitleCaseString,
  unpaidString,
} from '../../AB Membership/constants'

type Props = {
  status: string
  thopId: string
}
const styles = () => ({
  unpaidLink: {
    textTransform: 'initial',
    outline: 'border-box',
    background: '#E35335',
    color: 'white',
    padding: '0px 2px',
    fontSize: '10px',
    '&:hover': {
      background: '#E35335',
    },
  },
  paidLink: {
    textTransform: 'initial',
    outline: 'border-box',
    background: 'green',
    color: 'white',
    padding: '0px 2px',
    fontSize: '10px',
    '&:hover': {
      background: 'green',
    },
  },
  endIcon: {
    fontSize: '13px !important',
  },
})

const BillingLink = ({ status, thopId }: Props) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const locationId = useAppSelector(selectSelectedLocationId)
  const handleClick = () => {
    startSxpProxy(CHAT_PROJECT_ID, 'unpaidAppointments', {
      id: thopId,
      selectedLocationId: locationId,
    })
      .then((data) => {
        const id = data.data?.[0]?.id
        if (!id) {
          alert('Invoice not available. Please contact Admin')
          return
        }
        startSxpProxy(ADMIN_PROJECT_ID, odooPharmacyLink, {
          invoiceId: id,
          location: locationId,
        })
          .then((data) => {
            const url = data?.data?.auth_link
            window.open(url, '_blank', 'noopener,noreferrer')
          })
          .catch((err) => console.error(err, 'err'))
      })
      .catch((err) => console.error(err))
  }

  return (
    <Button
      size='small'
      className={`${
        status === proposed ? classes?.unpaidLink : classes?.paidLink
      }`}
      endIcon={
        status === proposed ? (
          <OpenInNewIcon className={classes?.endIcon} />
        ) : (
          <CheckCircleOutlineIcon className={classes?.endIcon} />
        )
      }
      onClick={handleClick}
    >
      {status === proposed ? unpaidString : paidTitleCaseString}
    </Button>
  )
}

export default BillingLink
